export enum PayPalEnvironment {
    Sandbox = 'sandbox',
    Production = 'production'
}
